import React from "react";

function Timer(){
    return (
        <div
            style={{
                position: "fixed",
                top: "80px",
                right: "20px",
                padding: "10px",
                background: "#FC0388",
                color: "#FFFFFF",
                borderRadius: "5px",
                boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
                zIndex: "1000",
            }}
        >
            Time: 20
        </div>
    );
};

export default Timer;